export const ONE_REP_MAX_CHART_MARGIN = { top: 30, right: 20, bottom: 30, left: 60 };
